import { getErrorType } from 'wa-storybook/global/constants/error-messages';
import { getWalletCurrencySymbol } from 'globals/helpers';

export default function (code, extraParams?) {
  return polyglot.t(
    `api_errors.${getErrorType(code) || 'something_wrong'}`,
    Object.assign({}, { currency: getWalletCurrencySymbol() }, extraParams),
  );
}
